import {
  Paper,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Countdown from "../../countDown";
import ReactCodeInput from "react-verification-code-input";

/*----components----*/
import CountryCode from "../../countryCode";
import DialogConfirm from "../../dialog";
import PopUpEnterActiveCode from "../../popUpInterface";
import Snackbar from "../../snackbar";
import Loading from "../../loading";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import InputFormat from "../../../partials/inputForm";
import SelectedBranch from "../../selectedBranch";
import Header from "../../../partials/header";
/*----styles----*/
import { styles } from "./styles";
class AddEmployee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enterActiveCode: false,
      openDialogs: true,
      phoneNumber: "",
      countryCode: this.props.defaultCountryCode || "+84",
      activeCode: { value: "" },
      typeEmployee: "operator",
      branch: [],
      expiredTime: 0,
      showExpired: true,
    };
    this.typeEmployee = ["operator", "executor"];
    this.sendActiveCode = this.sendActiveCode.bind(this);
    this.checkDataBeforeSendCode = this.checkDataBeforeSendCode.bind(this);
    this.handleCountryCode = this.handleCountryCode.bind(this);
    // this.handleDialogOpen = this.handleDialogOpen.bind(this);
    this.checkActiveCode = this.checkActiveCode.bind(this);
  }
  async sendActiveCode(payload) {
    const _this = this;
    let { t, serviceSetting = {}, service } = this.props;
    if (payload && payload.resend) this.loadingActiveCode.startLoading();
    else this.loading.startLoading();
    let check = await this.props.employeeDispatch.createActiveCode({
      eventType: "inviteEmployee",
      countryCode: this.state.countryCode,
      username: this.state.phoneNumber,
      typeEmployee: this.state.typeEmployee,
      code:
        this.state.code ||
        `${serviceSetting.prefixEmployee}${serviceSetting.totalEmployee + 1}`,
      arrBranch:
        this.state.branch === "all"
          ? JSON.stringify(this.filterArrBranch(this.props.listBranch))
          : JSON.stringify(this.state.branch),
    });
    if (payload && payload.resend) this.loadingActiveCode.stopLoading();
    else this.loading.stopLoading();
    if (check.code === 1) {
      if (check.data) {
        let expiredTime = check.data.expired
          ? Number(check.data.expired) - new Date().getTime()
          : 0;
        this.setState(
          {
            expiredTime: expiredTime,
            message: `${service.name} ${t(
              "employee_addemployee_invite_within_three_days"
            )}`,
            link: check.data.link,
          },
          function () {
            _this.countdown.start();
          }
        );
        if (!check.data.isRegister)
          this.PopUpEnterActiveCode.handleDialogOpen();
        else {
          this.mShowMessage.handleDialogOpen();
        }
      }
    } else {
      switch (check.error) {
        case 1112: {
          this.mSnackbar.handleClick(
            t(
              "employee_addemployee_phone_number_not_register_account_please_try_again"
            ),
            "error"
          );
          break;
        }
        case 1114: {
          this.mSnackbar.handleClick(
            t(
              "employee_addemployee_phone_number_existed_on_employee_management_system_please_try_again"
            ),
            "error"
          );
          break;
        }
        case 1115: {
          this.PopUpEnterActiveCode.handleDialogOpen();
          let expiredTime = check.data
            ? Number(check.data) - new Date().getTime()
            : 0;
          this.setState({ expiredTime: expiredTime }, function () {
            _this.countdown.start();
          });

          this.mSnackbarActiveCode.handleClick(
            t(
              "employee_addemployee_the_active_code_unexpired_so_you_can_not_request_again"
            ),
            "warning"
          );
          break;
        }
        case 1130: {
          this.mSnackbar.handleClick(
            t("employee_addemployee_error_with_code") + " " + check.error,
            "error"
          );
          break;
        }
        case 1128: {
          this.mSnackbar.handleClick(
            t(
              "employee_addemployee_user_had_role_owner_or_employee_for_this_spa"
            ),
            "error"
          );
          break;
        }
        case 1131:
        case 1132: {
          this.mSnackbar.handleClick(
            t("employee_addemployee_error_with_code") + " " + check.error,
            "error"
          );
          break;
        }
        default: {
          this.mSnackbar.handleClick(
            t(
              "employee_addemployee_an_error_occurred_please_try_again_or_contact_your_administrators"
            ) + check.message,
            "error"
          );
          break;
        }
      }
    }
  }
  filterArrBranch(arrBranch) {
    let newArrBranch = [];
    arrBranch.forEach((branch) => {
      newArrBranch.push(branch.branchCode);
    });
    return newArrBranch;
  }
  changeArrBranch = async (arrBranch) => {
    this.setState({
      branch: arrBranch,
    });
  };
  handleChangeActiveCode = (value) => {
    let activeCode = this.state.activeCode;
    activeCode.value = value;
    this.setState({ activeCode });
  };
  async checkActiveCode() {
    let { t, serviceSetting = {} } = this.props;
    this.loadingActiveCode.startLoading();
    let activeCode = this.state.activeCode.value;
    // let activeCode = document.getElementById("activeCodeInput").value;
    let check = await this.props.employeeDispatch.checkActiveCode({
      eventType: "inviteEmployee",
      countryCode: this.state.countryCode,
      username: this.state.phoneNumber,
      activeCode: activeCode,
      typeEmployee: this.state.typeEmployee,
      code:
        this.state.code ||
        `${serviceSetting.prefixEmployee}${serviceSetting.totalEmployee + 1}`,
      arrBranch:
        this.state.branch === "all"
          ? JSON.stringify(this.filterArrBranch(this.props.listBranch))
          : JSON.stringify(this.state.branch),
    });
    this.loadingActiveCode.stopLoading();
    if (check.code) {
      this.props.history.push("/employee");
    } // this.mSnackbar.handleClick(t('employees_add_new_employee_successfully'))
    else {
      switch (check.error) {
        case 1116: {
          this.mSnackbarActiveCode.handleClick(
            t("active_code_expired"),
            "warning"
          );
          break;
        }
        case 1117: {
          this.mSnackbarActiveCode.handleClick(
            t(
              "employee_addemployee_the_active_code_incorrect_please_try_again"
            ),
            "warning"
          );
          break;
        }
        case 1112: {
          this.mSnackbarActiveCode.handleClick(
            t(
              "employee_addemployee_phone_number_not_register_account_please_try_again"
            ),
            "warning"
          );
          break;
        }
        case 1130: {
          this.mSnackbarActiveCode.handleClick(
            t("employee_addemployee_error_with_code") + " " + check.error,
            "warning"
          );
          break;
        }
        default: {
          this.mSnackbarActiveCode.handleClick(
            t(
              "employee_addemployee_an_error_occurred_please_try_again_or_contact_your_administrators"
            ),
            "warning"
          );
          break;
        }
      }
    }
  }
  checkDataBeforeSendCode() {
    let { t } = this.props;
    let { branch, countryCode, phoneNumber } = this.state;
    if (!_parsePhoneNumber(countryCode, phoneNumber).isValid) {
      this.mSnackbar.handleClick(
        t("employee_addemployee_phone_number_no_valid_please_try_again"),
        "warning"
      );
    } else if (!branch || !branch.length) {
      this.mSnackbar.handleClick(
        t("employee_addemployee_please_pick_a_branch_at_least"),
        "warning"
      );
    } else this.sendActiveCode();
  }
  handleChange = (e) => {
    let name = e.target.name;
    this.setState({ [name]: e.target.value });
  };
  handleCountryCode = (name, value) => {
    this.setState({
      countryCode: value,
    });
  };
  closeMessage = () => {
    this.mShowMessage.handleDialogClose();
    if (this.props.history) this.props.history.push("/employee");
  };
  render() {
    const { classes, t, serviceSetting } = this.props;
    const { message, link } = this.state;
    let number = _parsePhoneNumber(
      this.state.countryCode,
      this.state.phoneNumber
    ).format_internal;
    if (!number) number = this.state.countryCode + this.state.phoneNumber;
    return (
      <Fragment>
        <PopUpEnterActiveCode
          onRef={(dialog) => (this.PopUpEnterActiveCode = dialog)}
          flagOpen={false}
          handleDialogClose={() =>
            this.PopUpEnterActiveCode.handleDialogClose()
          }
          paperWidth={classes.paperWidth}
        >
          <Loading onRef={(id) => (this.loadingActiveCode = id)} />
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbarActiveCode = snackbar)}
          />
          <DialogTitle
            id="scroll-dialog-title"
            disableTypography
            style={{ padding: 0 }}
          >
            <Typography variant="h2" className={classes.title}>
              {t("employee_addemployee_invite_employee")}
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.DialogContent}>
            <Grid container spacing={3} className={classes.wrapGrid}>
              <Grid item xs={12} sm={12}>
                <Typography variant="h6" className={classes.content}>
                  {t(
                    "employee_addemployee_enter_activecode_send_to_phone_number"
                  )}{" "}
                  {number} {t("employee_addemployee_to_confirm")}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <ReactCodeInput
                  onComplete={this.checkActiveCode}
                  onChange={this.handleChangeActiveCode}
                  value={this.state.activeCode.value}
                  fieldWidth={60}
                  fieldHeight={54}
                  autoFocus={true}
                />
                {/* <InputFormat
                  required
                  useValue={false}
                  disableUnderline
                  placeholder="Active Code"
                  name="activeCode"
                  id="activeCodeInput" // Không dùng state để component countdown không chạy lại từ đầu
                /> */}
              </Grid>
              <Grid item xs={12} sm={12} className={classes.footerActiveCode}>
                <Countdown
                  onRef={(id) => (this.countdown = id)}
                  expiredTime={this.state.expiredTime}
                  resend={() => this.sendActiveCode({ resend: true })}
                />
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => this.checkActiveCode()}
                >
                  {t("employee_addemployee_add_new_employee")}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </PopUpEnterActiveCode>

        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <DialogConfirm
          onRef={(dialog) => (this.mShowMessage = dialog)}
          agree={t("ok")}
          title={t("employee_addemployee_notice")}
          content={[
            <div className={classes.boxMess}>
              <div className={classes.titleMess}>{`${t(
                "you_send_message_to_phone"
              )} ${number} ${t("with_content")}`}</div>
              <div className={classes.message}>
                {message} <a href={link}>{link}</a>
              </div>
            </div>,
          ]}
          action={this.closeMessage}
        />
        <DialogConfirm
          onRef={(dialog) => (this.DialogConfirm = dialog)}
          disagree={t("employee_addemployee_cancel")}
          agree={t("employee_addemployee_send")}
          title={t("employee_addemployee_notice")}
          content={t(
            "employee_addemployee_send_an_activeCode_to_this_phone_number_and_invite_them_become_employee"
          )}
          action={this.sendActiveCode}
        />
        <Header
          session={t("sidebar_manage")}
          title={t("employee_addemployee_invite_employee")}
          backIcon={true}
          actionBack={() => this.props.history.push("/employee")}
        />
        {/* <DialogTitle id="scroll-dialog-title" disableTypography style={{ padding: 0 }}>
                        <Typography variant="h2" className={classes.title}>{t('employee_addemployee_invite_employee')}</Typography>
                    </DialogTitle> */}
        {/* <DialogContent className={classes.DialogContent}> */}
        <Paper className={classes.root}>
          <Grid container spacing={3} className={classes.wrapGrid}>
            <Grid item xs={12} sm={3}>
              <CountryCode
                code={this.state.countryCode}
                handleCountryCode={this.handleCountryCode}
              />
            </Grid>
            <Grid item xs={12} sm={9}>
              <InputFormat
                required
                label={t("employee_addemployee_phone_number")}
                value={this.state.phoneNumber}
                name="phoneNumber"
                placeholder={t("employee_addemployee_type_phone_number")}
                onChange={(event) => this.handleChange(event)}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputFormat
                required
                label="Code"
                name="code"
                value={
                  this.state.code ||
                  `${serviceSetting.prefixEmployee}${
                    serviceSetting.totalEmployee + 1
                  }`
                }
                onChange={(event) => this.handleChange(event)}
                className={classes.textField}
              />
            </Grid>
            <Grid item xs={12} sm={9} className={classes.TextFieldGroup}>
              <InputFormat
                select
                label={t("employee_addemployee_type_employee")}
                name="typeEmployee"
                value={this.state.typeEmployee}
                onChange={(event) => this.handleChange(event)}
              >
                {this.typeEmployee.map((type, i) => {
                  return (
                    <MenuItem key={`${type}-${i}`} value={type}>
                      {t("employee_addemployee_" + type)}
                    </MenuItem>
                  );
                })}
              </InputFormat>
            </Grid>
            <Grid item xs={12} sm={12}>
              <SelectedBranch
                onRef={(id) => (this.SelectedBranch = id)}
                multiple={true}
                required={true}
                value={this.state.branch}
                handleChangeBranch={(arrBranch) =>
                  this.changeArrBranch(arrBranch)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} className={classes.footerEnterPhone}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => this.checkDataBeforeSendCode()}
              >
                {t("employee_addemployee_confirm")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
        {/* </DialogContent> */}
      </Fragment>
    );
  }
}
const mapState = (state) => ({
  listBranch: state.serviceBranch.listBranch,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
  serviceSetting: state.serviceSetting.serviceSetting,
  service: state.service.service,
});
const mapDispatch = (dispatch) => ({
  employeeDispatch: dispatch.employees,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(AddEmployee)
  )
);
